import { GraphQLClient } from "graphql-request";
import { useContext } from "react";
import { useQuery } from "@tanstack/react-query";

import { FIND_MEMBER } from "../utils/queries";
import { MemberItem } from "../utils/daotypes";
import { getGraphUrl } from "../utils/endpoints";
import { DaoHooksContext } from "../contexts/DaoHooksContext";
import { buildMemberSubgraphId } from "@/lib/dao-ids";

export const useMember = ({
  chainid,
  memberaddress,
  daoid,
}: {
  chainid?: string;
  memberaddress?: string;
  daoid?: string;
}) => {
  const hookContext = useContext(DaoHooksContext);

  if (!hookContext || !hookContext.config.graphKey) {
    console.error(
      "useMember: DaoHooksContext must be used within a DaoHooksProvider"
    );
  }

  const dhUrl = getGraphUrl({
    chainid: chainid || "",
    graphKey: hookContext?.config.graphKey || "",
    subgraphKey: "DAOHAUS",
  });

  const graphQLClient = new GraphQLClient(dhUrl);

  const { data, ...rest } = useQuery({
    queryKey: [`get-member`, { chainid, daoid, memberaddress }],
    enabled: Boolean(chainid && memberaddress && daoid),
    queryFn: async (): Promise<{
      member: MemberItem;
    }> => {
      const memberid = buildMemberSubgraphId({
        daoId: daoid,
        memberAddress: memberaddress,
        fallbackChainId: chainid,
      })

      if (!memberid) {
        throw new Error("Missing DAO or member address for subgraph lookup")
      }

      const res = (await graphQLClient.request(FIND_MEMBER, {
        memberid,
      })) as {
        member: MemberItem;
      };

      return {
        member: res.member,
      };
    },
  });

  return {
    member: data?.member,
    ...rest,
  };
};
